import { render, staticRenderFns } from "./UpdatesSetup.vue?vue&type=template&id=246b1226&scoped=true&"
import script from "./UpdatesSetup.vue?vue&type=script&lang=ts&"
export * from "./UpdatesSetup.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatesSetup.vue?vue&type=style&index=0&id=246b1226&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b1226",
  null
  
)

export default component.exports